export default function (data, type) {
  const result = baseSchema(type);
  switch (type?.toLowerCase()) {
    case 'website':
      Object.assign(result.json, webSiteJson(data));
      result.json.publisher = organizationJson(data.organization?.fields);
      break;

    case 'webpage':
      Object.assign(result.json, webPageJson(data));
      result.json.publisher = organizationJson(data.route?.fields?.organization?.fields);
      break;

    case 'organization':
      Object.assign(result.json, organizationJson(data.organization?.fields));
      break;

    case 'breadcrumblist':
      Object.assign(result.json, breadcrumbListJson(data));

      // Check for Missing Breadcrumb Data
      if (result.json.error) {
        result.error = result.json.error;
        delete result.json.error;
      }
      break;

    case 'custom':
      Object.assign(result.json, customJson(data));

      // Check for JSON Parsing Error
      if (result.json.error) {
        result.error = result.json.error;
        delete result.json.error;
      }
      break;

    default:
      console.error(`Schema type not recognized: ${type}`);
  }
  // Convert object into JSON string so unhead/vue code can add it to a <script> element.
  result.innerHTML = JSON.stringify(result.json);
  delete result.json;

  return result;
}

function baseSchema(type) {
  const result = {
    type: 'application/ld+json',
    hid: `${type?.toLowerCase()}-json-ld`,
    json: {
      '@context': 'https://schema.org'
    }
  };
  return result;
}

function webSiteJson(data) {
  if (!data) return {};

  const result = {
    '@type': 'WebSite',
    name: data.name?.value,
    url: data.url?.value,
    potentialAction: {
      '@type': 'SearchAction',
      target: data.searchActionTarget?.value,
      'query-input': data.searchQueryInput?.value
    }
  };

  return result;
}

function webPageJson(data) {
  if (!data) return {};

  const page = data.route.fields;
  if (!page) return {};

  const result = {
    '@type': 'WebPage',
    name: page.structuredDataTitle?.value?.trim() || page.pageTitle?.value?.trim(),
    description:
      page.structuredDataDescription?.value?.trim() || page.pageDescription?.value?.trim(),
    url: data.canonicalUrl || '',
    image: page.structuredDataImage?.value?.src || page.featuredImage?.value?.src
  };

  return result;
}

function organizationJson(data) {
  if (!data) return undefined;

  const result = {
    '@type': 'Organization',
    name: data.name?.value?.trim(),
    telephone: data.telephone?.value?.trim(),
    image: data.logo?.value?.src,
    description: data.description?.value?.trim(),
    url: data.url?.value
  };

  const urlArray = data.relatedUrls?.value
    ?.split('\n')
    ?.map((u) => u.trim())
    ?.filter((u) => u.length > 0);
  if (urlArray) {
    result.sameAs = urlArray;
  }

  if (data.postalAddress?.fields) {
    const address = data.postalAddress.fields;
    result.address = {
      '@type': 'PostalAddress',
      addressCountry: address.country?.value?.trim(),
      addressRegion: address.region?.value?.trim(),
      addressLocality: address.locality?.value?.trim(),
      postalCode: address.postalCode?.value?.trim(),
      streetAddress: address.street?.value?.trim()
    };
  }

  if (data.contactPoints && data.contactPoints.length > 0) {
    result.contactPoint = data.contactPoints.map((c) => {
      return {
        '@type': 'ContactPoint',
        contactType: c.fields?.contactType?.value,
        telephone: c.fields?.telephone?.value,
        email: c.fields?.email?.valaue
      };
    });
  }

  return result;
}

function articleJson(data) {}

function breadcrumbListJson(data) {
  let result;

  // If we have a partnerTypes GUID, return partner breadcrumbs.
  if (data.partnerUrl.length > 0) {
    result = {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: data.partnerDisplayName,
          item: data.sitecoreApiHost + data.partnerUrl
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: data.pageTitle
        }
      ]
    };
    // If we have breadcrumb parent data, return normal breadcrumbs.
  } else if (data.parents && data.parents.length) {
    result = {
      '@type': 'BreadcrumbList',
      itemListElement: []
    };

    data.parents.forEach(function (item, index) {
      if (index > 0) {
        const hostName = item.url.startsWith('http') ? '' : data.sitecoreApiHost;
        result.itemListElement.push({
          '@type': 'ListItem',
          position: index,
          name: item.title,
          item: hostName + item.url
        });
      }
    });

    result.itemListElement.push({
      '@type': 'ListItem',
      position: data.parents.length,
      name: data.pageTitle
    });
    // Else return error.
  } else {
    result = { error: 'no-breadcrumb-data' };
  }

  return result;
}

function customJson(data) {
  if (!data) return { error: 'no-data' };

  const page = data.route.fields;
  let result;

  if (page && page.structuredDataCustom?.value && page.structuredDataCustom?.value?.trim().length) {
    try {
      result = JSON.parse(page.structuredDataCustom?.value?.trim());
    } catch (e) {
      console.error(e);
      result = { error: e.message };
    }
  } else {
    result = { error: 'no-custom-json-ld' };
  }

  return result;
}

function faqJson(data) {}
